import type { ChatConversationMember } from "@/components/shared/chat-message-types";

interface SendbirdMemberLike {
  userId: string;
  nickname?: string;
  profileUrl?: string;
  metaData?: { role?: string };
}

// @todo - migrate once RBAC migration is complete
function normalizeSendbirdRole(role: string | undefined): string[] | undefined {
  if (role === "MENTEE") return ["mentee"];
  if (role) return ["mentor"];
  return undefined;
}

export function normalizeConversationMembers(
  members: SendbirdMemberLike[] | undefined,
): ChatConversationMember[] {
  return (
    members?.map((member) => ({
      id: member.userId,
      name: member.nickname,
      avatarUrl: member.profileUrl,
      systemRoles: normalizeSendbirdRole(member.metaData?.role),
    })) ?? []
  );
}
